import type { GDSStatus } from '@leagueplatform/genesis-core';

export const SEVERITY_VALUES = [
  'informational',
  'warning',
  'critical',
] as const;
export type SeverityValue = (typeof SEVERITY_VALUES)[number];

/**
 * Authoring enum value → Genesis component status. This mirrors the backend's
 * display mapping (`mapToAlertBanner`), so the authoring preview matches what
 * the member app renders. Note `GDSStatus` has no `critical`, so `critical`
 * maps to `error`. Any new severity value must map to a valid `GDSStatus`.
 */
export const SEVERITY_STATUS: Record<SeverityValue, GDSStatus> = {
  informational: 'info',
  warning: 'warning',
  critical: 'error',
};

export const isSeverityValue = (value: unknown): value is SeverityValue =>
  typeof value === 'string' &&
  (SEVERITY_VALUES as readonly string[]).includes(value);
